<div>
    <vl-alert
        v-for="message in messages"
        :key="message.id"
        :icon="message.icon"
        :title="message.title"
        :closable="message.isClosable"
        @close="closeMessage(message.id)"
        v-bind="getAlertModifiers(message)">
        <div v-html="message.message"></div>
    </vl-alert>
</div>
